import { render } from "./HandToShippingModal.vue?vue&type=template&id=f13acd0c&scoped=true&ts=true&lang=pug"
import script from "./HandToShippingModal.vue?vue&type=script&lang=ts"
export * from "./HandToShippingModal.vue?vue&type=script&lang=ts"

import "./HandToShippingModal.vue?vue&type=style&index=0&id=f13acd0c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f13acd0c"]])

export default __exports__